import React from 'react'

import { Outlet } from 'react-router-dom'
import { OutletWrapper } from '@base'

const AdminContent = () => {
	return (
		<OutletWrapper>
			<Outlet />
		</OutletWrapper>
	)
}

export default AdminContent
